export const resumeData = {
  header: {
    name: "Girish Kumar Goyal",
    title: "Software Engineer · Systems & Algorithms",
    location: "Bulandshahr, Uttar Pradesh, India",
    email: "gk.goyal.0.03@gmail.com",
    links: [
      { name: "Email", url: "mailto:gk.goyal.0.03@gmail.com", label: "gk.goyal.0.03@gmail.com" },
      { name: "Codeforces", url: "https://codeforces.com/profile/epsilon_xd", label: "codeforces.com/profile/epsilon_xd" },
      { name: "LinkedIn", url: "https://www.linkedin.com/in/girish-kumar-goyal-189152198/", label: "linkedin.com/in/girish-kumar-goyal" },
      { name: "GitHub", url: "https://github.com/Girish-1-Goyal", label: "github.com/Girish-1-Goyal" },
      { name: "Portfolio", url: "https://girishgoyal.netlify.app/", label: "girishgoyal.netlify.app" }
    ]
  },
  
  education: [
    {
      institution: "G.L. Bajaj Group of Institutions",
      location: "Mathura, Uttar Pradesh, India",
      degree: "B.Tech in Computer Science and Engineering",
      score: "CGPA: 6.80 / 10.0",
      period: "2018 – 2022",
      coursework: [
        "Data Structures and Algorithms",
        "Machine Learning",
        "Discrete Mathematics",
        "Computer Architecture",
        "Operating Systems",
        "Database Management Systems"
      ]
    },
    {
      institution: "Smt. Sridevi Awasiya Vidhyapeeth School",
      location: "Agra, Uttar Pradesh, India",
      degree: "AISSCE (CBSE Class XII)",
      score: "Percentage: 68.2%",
      period: "2018"
    },
    {
      institution: "Keshav Madhav Saraswati Vidhya Mandir Sen. Sec. School",
      location: "Kakore, Uttar Pradesh, India",
      degree: "AISSE (CBSE Class X)",
      score: "CGPA: 7.0 / 10.0",
      period: "2015"
    }
  ],

  achievements: [
    {
      title: "Codeforces Candidate Master (Max Rating: 2013)",
      description: "Achieved Candidate Master title on Codeforces with 1,000+ algorithmic problems solved across competitive platforms."
    },
    {
      title: "College Coding Contest Winner (Rank 1)",
      description: "Ranked 1st out of 200+ participants in the inter-college programming contest by achieving the highest score."
    },
    {
      title: "Codeforces Global Ranks",
      description: "Secured Top 500 rank twice and Top 1000 rank four times in Codeforces Div. 1 + Div. 2 global rated rounds."
    },
    {
      title: "Coding Club Lead & Mentor",
      description: "Led college Coding Club, organized 5+ competitive programming contests, and mentored 100+ junior engineers."
    },
    {
      title: "Author — Data Structures & Algorithms Reference Handbook",
      description: "Authored an in-depth reference handbook in C++ typeset in LaTeX with visual memory layouts and rigorous complexity proofs."
    }
  ],

  skills: {
    languages: ["C", "C++", "Python", "JavaScript", "TypeScript", "SQL"],
    technologies: ["React.js", "Angular", "Node.js", "PostgreSQL", "Docker", "Git", "LaTeX", "REST APIs", "System Design", "Material UI", "Tailwind CSS"],
    operatingSystems: ["Linux (Arch Linux, Debian, Ubuntu, Kali Linux, Pop!_OS)"],
    curiosities: ["Evolutionary Biology", "Cellular Automata", "Molecular Genetics", "Natural Systems"],
    spokenLanguages: ["English", "Hindi"]
  },

  experience: [
    {
      company: "Knoldus Softwares LLP",
      location: "Noida, Uttar Pradesh, India",
      role: "Frontend Developer Intern",
      period: "Nov 2021 – March 2022",
      highlights: [
        "Collaborated in an agile engineering team to develop responsive dashboard interfaces using Angular and TypeScript.",
        "Integrated REST API endpoints and implemented structured client-side state management for user panels.",
        "Contributed to internal portal modules with clean, reusable TypeScript components and unit testing.",
        "Utilized Docker for local containerized development workflows and maintained version control through Git."
      ]
    }
  ],

  projects: [
    // =========================================================================
    // ACTIVE & IN-PROGRESS SYSTEMS (TOP)
    // =========================================================================
    {
      title: "Multi-Tenant SaaS College Coding Club Platform",
      tech: "React.js, Node.js, TypeScript, PostgreSQL, Docker, Tailwind CSS",
      period: "2024 – Present",
      status: "IN PROGRESS",
      points: [
        "Building a multi-tenant platform for university coding clubs with isolated chapter spaces and role-based access control (RBAC).",
        "Developing automated competitive programming contest management, real-time leaderboard ranking queries, and member tracking.",
        "Designing modular full-stack services with PostgreSQL relational schemas and responsive administration dashboards."
      ],
      links: {
        github: null,
        demo: null
      }
    },
    {
      title: "Independent Software Systems & Developer Tooling",
      tech: "C, C++, React.js, Local-First Architecture",
      period: "2024 – Present",
      status: "IN PROGRESS / STEALTH",
      points: [
        "Prototyping independent developer utilities and local-first software tools with minimal runtime dependencies and deterministic execution.",
        "Designing modular command dispatch interfaces and high-performance algorithms for offline-capable technical workflows."
      ],
      links: null
    },

    // =========================================================================
    // COMPLETED ARCHITECTURES (BOTTOM)
    // =========================================================================
    {
      title: "Data Structures & Algorithms Reference Handbook",
      tech: "LaTeX, C++, TikZ, Technical Writing",
      period: "2023",
      status: "COMPLETED",
      points: [
        "Authored a comprehensive technical desktop reference covering arrays, linked lists, binary search trees, segment trees, heaps, and graph algorithms.",
        "Typeset in LaTeX with mathematical proofs, memory layout diagrams rendered with TikZ, and clean idiomatic C++20 implementations.",
        "Conducted detailed asymptotic time and space complexity analyses for every algorithmic paradigm with practical competitive programming applications."
      ],
      links: {
        github: "https://github.com/Girish-1-Goyal/dsa-handbook",
        demo: "https://drive.google.com/file/d/12CLQ1KWekgsH4rcJUSxIJmH-d_iVN0ae/view?usp=drive_link"
      }
    },
    {
      title: "Unix Web Terminal Emulator",
      tech: "React.js, JavaScript, Python, Flask, CSS3",
      period: "2023",
      status: "COMPLETED",
      points: [
        "Developed an interactive browser-based terminal application emulating standard Unix command-line mechanics with stateful directory traversal.",
        "Engineered a modular command dispatch system with in-memory circular history buffers (Up/Down readline navigation) and keyboard event lifecycle handling.",
        "Paired with a lightweight command handler backend for extensible scripting workflows."
      ],
      links: {
        github: "https://github.com/Girish-1-Goyal/WebTerminal-Project-",
        demo: "https://webterm-u.netlify.app/"
      }
    },
    {
      title: "POSIX Minimalist Command Shell",
      tech: "C, Linux, POSIX System Calls, GNU Make",
      period: "2022",
      status: "COMPLETED",
      points: [
        "Built a POSIX-compliant minimalist command shell in C from scratch with custom line reading, whitespace tokenization, and command dispatch.",
        "Implemented process creation via fork(), binary execution with execvp(), and child process monitoring with waitpid().",
        "Implemented core built-in shell commands (cd, pwd, exit) and handled signal interrupts (SIGINT, SIGTSTP)."
      ],
      links: {
        github: "https://github.com/Girish-1-Goyal/Terminal-C-Simple",
        demo: null
      }
    }
  ]
};
